module.exports = __webpack_public_path__ + "media/assets/images/flags/om-2065d5d5ee6c8152c2fa708027c5ccf1.svg";